import CartsShowView from "./carts";
import { General, Flash} from "./general";
import { CheckoutOverview, CheckoutPaymentAndShippingView } from "./checkout";
import { ProductsIndexView, ProductsShowView } from "./products";
import { RegistrationAddressView, RegistrationRegNoView } from "./registration";
import Sidebar from "./sidebar";
import Utils from "./utils";

// COMPONENTS
import AjaxListener from "./components/ajax_listener";
import Notices from "./components/notices";
import Modal from "./components/modal";
import Switcher from "./components/switcher";
import TurboLoader from "./components/turbo_loader.js.erb"

// Must be require due it is jQuery plugin.
require('jquery-validation/dist/jquery.validate');

require('bootstrap-select/js/bootstrap-select');

require('jquery-lazyload/jquery.lazyload');

const UTIL = {
  exec: function( controller, action ) {
    var ns = SITENAME,
      action = ( action === undefined ) ? "init" : action;

    if ( controller !== "" && ns[controller] && typeof ns[controller][action] == "function" ) {
      ns[controller][action]();
    }
  },

  init: function() {
    var body = document.body,
      controller = body.getAttribute( "data-controller" ),
      action = body.getAttribute( "data-action" );

    UTIL.exec( "common" );
    UTIL.exec( controller );
    UTIL.exec( controller, action );
  }
};

const SITENAME = {
  common: {
    init: function() {
      // Unbinds all event listeners with mixit namespace.
      $('*').off('.mixit');

      // General init
      General.init();

      // Components init
			Utils.init();
			TurboLoader.init();

      AjaxListener.init();
      Notices.init();
    }
  },

  products: {
    index: function() {
      ProductsIndexView.init();
			Sidebar.init();
    },
    show: function() {
      ProductsShowView.init();
			Sidebar.init();
    }
  },

  properties: {
    show: function() {
      ProductsIndexView.init();
    }
  },

  registration: {
    init: function() {

    },

    company_reg_no: function() {
      RegistrationRegNoView.init();
    },

    registration_address: function() {
      RegistrationAddressView.init();
    }
  },
  checkout: {
    init: function() {

    },

    payment_and_shipping: function() {
      CheckoutPaymentAndShippingView.init();
    },

    overview: function () {
      CheckoutOverview.init();
    }
  },
  carts: {
    init: function() {

    },

    show: function() {
      CartsShowView.init();
    }
  },
	news: {
  	init: function() {
  		Switcher.init();
		}
	}
};

document.addEventListener('turbolinks:load', function(e) {
  if (!$(".selectpicker").attr('initialized')) {
    $('.selectpicker').selectpicker();
    $('.selectpicker').attr('initialized', true)
  }

  // if (typeof dataLayer === "object") {
  //   dataLayer.push({
  //     'event': 'pageView',
  //     'virtualPageURL': location.pathname
  //   });
  // }

  UTIL.init();

  if(window.success) {
    if (window.success.modal) {
      Modal.showOkModal(window.success.modal_title || 'Úspěch', window.success.msg);
    }
    else {
      Flash.success(window.success.msg);
    }

    window.success = null;
  }

  if(window.error) {
    if (window.error.modal) {
      Modal.showErrorModal(window.error.modal_title || 'Došlo k chybě', window.error.msg);
    }
    else {
      Flash.error(window.error.msg);
    }

    window.error = null;
  }
});
